import { NotificationActionTypes, NotificationState } from "./types";
import { Reducer } from "redux";

export const initialState: NotificationState = {
	centerLoading: false,
	dropdownLoading: false,
	isMarkAllLoading: false,
	markingIds: [],
	centerList: [],
	dropdownList: [],
	error: undefined,
	pagination: {
		size: 0, page: 1, pages: 0, total: 0, elements: 0,
		last: false, first: true, offset: 0,
		hasNext: false, hasPrevious: false,
		unreadByType: {}, totalUnread: 0
	}
};

const reducer: Reducer<NotificationState> = (state = initialState, action: any) => {
	const scope = action.meta?.scope || "center";
	const listKey = scope === "dropdown" ? "dropdownList" : "centerList";
	const loadingKey = scope === "dropdown" ? "dropdownLoading" : "centerLoading";

	switch (action.type) {
		case NotificationActionTypes.GET_NOTIFICATIONS_REQUEST:
			return { ...state, [loadingKey]: true };

		case NotificationActionTypes.GET_NOTIFICATIONS_SUCCESS:
			return {
				...state,
				[loadingKey]: false,
				[listKey]: action.meta?.append
					? [...state[listKey], ...action.payload.content]
					: action.payload.content,
				pagination: action.payload.pagination
			};

		case NotificationActionTypes.GET_NOTIFICATIONS_ERROR:
			return { ...state, [loadingKey]: false, error: action.payload };

		case NotificationActionTypes.MARK_AS_READ_REQUEST:
			return { ...state, markingIds: [...state.markingIds, action.payload] };

		case NotificationActionTypes.MARK_AS_READ_SUCCESS: {
			const id = action.payload;
			const updatedList = state[listKey].map(n =>
				n.id === id ? { ...n, read_status: "READ" } : n
			);
			const prev = state.pagination.unreadByType;
			const type = updatedList.find(n => n.id === id)?.type || "";
			const updatedByType = { ...prev, [type]: Math.max((prev[type] || 1) - 1, 0) };

			return {
				...state,
				markingIds: state.markingIds.filter(x => x !== id),
				[listKey]: updatedList,
				pagination: {
					...state.pagination,
					totalUnread: state.pagination.totalUnread - 1,
					unreadByType: updatedByType
				}
			};
		}

		case NotificationActionTypes.MARK_AS_READ_ERROR:
			return {
				...state,
				markingIds: state.markingIds.filter(x => x !== action.payload)
			};

		case NotificationActionTypes.MARK_ALL_AS_READ_REQUEST:
			return { ...state, isMarkAllLoading: true };

		case NotificationActionTypes.MARK_ALL_AS_READ_SUCCESS:
			return {
				...state,
				isMarkAllLoading: false,
				[listKey]: state[listKey].map(n => ({ ...n, read_status: "READ" })),
				pagination: { ...state.pagination, totalUnread: 0, unreadByType: {} }
			};

		case NotificationActionTypes.MARK_ALL_AS_READ_ERROR:
			return { ...state, isMarkAllLoading: false };

		case NotificationActionTypes.SSE_NEW_NOTIFICATION: {
			const incoming = action.payload;
			// check if we already have it
			const exists = state.dropdownList.some(n => n.id === incoming.id);
			if (exists) {
				return state;  // ignore the duplicate
			}
			return {
				...state,
				dropdownList: [incoming, ...state.dropdownList],
				pagination: {
					...state.pagination,
					totalUnread: state.pagination.totalUnread + 1,
					unreadByType: {
						...state.pagination.unreadByType,
						[incoming.type]: (state.pagination.unreadByType[incoming.type] || 0) + 1,
					}
				}
			};
		}

		default:
			return state;
	}
};

export { reducer as NotificationReducer };
